window.PlummeI18n.register('no', {
  'err.pensionCorrection.inactive': 'Ingen aktiv OTP-betaling å korrigere.',
  'err.pensionCorrection.legacy': 'Denne historiske OTP-betalingen må korrigeres etter regnskapsmessig gjennomgang.',
  'err.pensionCorrection.stale': 'OTP-betalingen er endret. Last inn siden på nytt før korrigering.',
  'err.pensionCorrection.reason': 'Oppgi årsaken til korrigeringen.',
  'err.pensionCorrection.reported': 'A-meldingen må gjennomgås før OTP i innrapportert lønn kan korrigeres.',
  'err.pensionCorrection.settled': 'Annuller terminbetalingen for arbeidsgiveravgift før OTP korrigeres.',
  'err.pensionCorrection.missing': 'Finner ikke bokføringen av OTP-betalingen.',
  'pay.viewPensionPosting': 'Se kontering',
  'pay.pensionDetails': 'Se betaling',
  'pay.correctPensionPayment': 'Korriger OTP-betaling',
  'pay.annulPensionPayment': 'Annuller OTP-betaling',
  'pay.pensionCorrectionSaved': 'OTP-betalingen er korrigert.',
  'pay.correctionReason': 'Årsak til korrigering',
  'pay.pensionCorrectionExplanation': 'Den opprinnelige OTP-betalingen motposteres i den opprinnelige, åpne perioden. Ved korrigering registreres en ny betaling. Lønnskjøringen og lønnsutbetalingen beholdes. Dette endrer bokføringen, ikke en utført bankoverføring.',
  'trv.approveExpense': 'Godkjenn utlegg',
  'pay.taxOnNonCashBenefits': 'Skattetrekk på naturalytelser',
  'pay.netReconciliation': 'Avvik mellom lønnslinjene og lagret netto',
  'pay.netAdjustmentExplanation': 'Trekkes fra kontant utbetaling; skatten er inkludert ovenfor.',
  'pay.viewPayslip': 'Se lønnsslipp',
  'pay.resendPayslip': 'Send på nytt',
  'pay.missingPensionBankAccountReminder': 'Du har ikke lagt til en bankkonto. Husk å legge til kontoen pensjonen er betalt fra. Du kan likevel registrere betalingen.',
  'pay.missingBankAccountReminder': 'Du har ikke lagt til en bankkonto. Husk å legge til kontoen lønnen er betalt fra. Du kan likevel registrere utbetalingen.',
});
